import React, {memo} from "react";
import {Button, Col, Row} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {
    actionChangeInvoiceModalShoppingCard,
    handelArrowModalShoppingCard,
    handelChangeLevelPaymentModalShoppingCard,
    handelToggleAnimationModalShoppingCard
} from "../../../../../../redux/actions/modals/modalShoppingCard";
import axios from "axios";
import {BASE_URL, FACTORS_PRE_POST} from "../../../../../../apis";
import qs from "querystring";
import {toast} from "react-toastify";
import {useRouteMatch} from "react-router-dom";

const QuestionsFooter = () => {
    const dispatch = useDispatch();
    const match = useRouteMatch();
    const store = useSelector(state => state.stores.list_stores.find(storeItem => storeItem.id === match.params.store));
    const {statusAnimation, activeSelectTablePostSchedule, activeDayPostSchedule, orderDescription, selectableQuestion} = useSelector(state => state.modalShoppingCard);
    const {carts} = useSelector(state => state.shoppingCart);

    const {token, activeAddress} = useSelector(state => state.user);
    const handelToggleAnim = () => {
        dispatch(handelToggleAnimationModalShoppingCard(!statusAnimation));
    };

    const handelNextLevelShoppingCard = () => {
        getDataInvoiceApi();
    };

    const getDataInvoiceApi = () => {
        let data = {
            store: store.id,
            address: activeAddress.addressId, delivery_time: activeSelectTablePostSchedule.id,
            delivery_day: activeDayPostSchedule,
            description: orderDescription,
            questions:''
        };
        for (const cart in carts) {
            data = carts[cart].optionSelect ? {...data, [`basket_products[${carts[cart].grades[0].gradeId}]`]: `${carts[cart].w_numbers}`,
                    [`options[${carts[cart].grades[0].gradeId}]`]: `${carts[cart].optionSelect.id}`}
                :
                {...data, [`basket_products[${carts[cart].grades[0].gradeId}]`]: `${carts[cart].w_numbers}`};
        }
        for (const key in selectableQuestion) {
            if (selectableQuestion[key].question !== 'reward') {
                data = {...data, 'questions': `${data.questions+( data.questions.length > 0 ? ',' : '' )+selectableQuestion[key].answerId}`};
            } else if (selectableQuestion[key].question === 'reward') {
                data = {...data, 'gratuity': selectableQuestion[key].answerTitle};
            }
        }

        if(localStorage.getItem("editOrderMode") !== undefined && localStorage.getItem("editOrderMode") !== null) // az safheye virayeshe sefaresh oomadim
            data = {...data, order: localStorage.getItem("editOrderMode")};

        /*const basket_products = _(carts).mapKeys(cart => `basket_products[${cart.grades[0].gradeId}]`)
            .mapValues(cart => cart.w_numbers).value();

        const options = _(carts).filter(cart => cart.optionSelect).mapKeys(cart => `options[${cart.grades[0].gradeId}]`)
            .mapValues(cart => cart.w_numbers).value();

        const questions = _(selectableQuestion)
            .filter(question => question.question !== 'reward')
            .value();

        const questions_2 = _(selectableQuestion)
            .find(question => question.question === 'reward')
            .mapKeys(() => 'gratuity')
            .mapValues(question => question.answerTitle).value();

        data = qs.stringify(_.assign(data, basket_products, options,questions,questions_2));*/

        axios({
            method: 'post',
            url: BASE_URL + FACTORS_PRE_POST,
            data: qs.stringify(data),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
        }).then(response => {
            switch (response.data.status) {
                case 'ok':
                    dispatch(actionChangeInvoiceModalShoppingCard(response.data));
                    dispatch(handelArrowModalShoppingCard('next'));
                    setTimeout(() => {
                            dispatch(handelChangeLevelPaymentModalShoppingCard('INVOICE', 'پیش فاکتور'));
                        }
                        , 400);
                    setTimeout(() => {
                        handelToggleAnim();
                    }, 100);
                    break;
                case'error':
                    toast.error(`${response.data.message}`, {
                        position: toast.POSITION.BOTTOM_CENTER
                    });
                    break;
                default:
                    toast.error('متاسفانه خطایی رخ داد دوباره تلاش کنید', {
                        position: toast.POSITION.BOTTOM_CENTER
                    });
                    break;
            }
        });
    };

    const handelPrevLevelShoppingCard = () => {
        dispatch(handelArrowModalShoppingCard('prev'));
        setTimeout(() => {
            dispatch(handelChangeLevelPaymentModalShoppingCard('POST_SCHEDULE', 'زمان بندی ارسال'));
        }, 400);
        setTimeout(() => {
            handelToggleAnim();
        }, 100);
    };
    return (
        <Row className={'w-100 m-auto'}>
            <Col xs={6} className={'mt-1'}>
                <Button variant="success" className={'base-btn-green'} block onClick={handelNextLevelShoppingCard}>
                    <span>مرحله بعدی</span>
                </Button>
            </Col>
            <Col xs={6} className={'mt-1'}>
                <Button variant="success" className={'base-btn-green-border'} block onClick={handelPrevLevelShoppingCard}>
                    <span>مرحله قبلی</span>
                </Button>
            </Col>

        </Row>
    );
};

export default memo(QuestionsFooter);
